import React from "react";
import { Controller } from "react-hook-form";
import { TextField, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  LocalizationProvider,
  DesktopDatePicker
} from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { generateGuid } from 'helpers';


const DATE_FORMAT = "DD / MM / yyyy";

export default function FormInputDate (props) {
  const [t, i18n ] = useTranslation();
  const { name, control, label, disabled, id, rules, position='vertical' } = props;
  let defaultId = !props?.id && generateGuid();

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Box
        sx={{
          display: 'flex',
          gap: 0.5,
          flexDirection: position === 'vertical' ? 'column' : 'row',
          alignItems: position === 'vertical' ? 'flex-start' : 'center'
        }}
      >
        { label &&
          <Typography variant="body1" id={`label-title-${defaultId}`}>
            {i18n.exists(label) ? t(label) : label}
          </Typography>
        }

        <Controller
          id={props?.id ? id : defaultId}
          name={props?.name ? name : defaultId}
          control={control}
          rules={{
            required: rules?.required && {
              value: rules.required.value,
              message: t(rules.required?.message ? rules.required.message : 'rules.required')
            }
          }}
          render={({ field, fieldState, formState }) => (
            <DesktopDatePicker              
              inputFormat={DATE_FORMAT}
              disabled={disabled}
              renderInput={(params) => <TextField size="small" {...params}/>}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              {...field }
            />
          )}
        />
      </Box>
    </LocalizationProvider>
  );
}
